// Copyright 2026 The Simlin Authors. All rights reserved.
// Use of this source code is governed by the Apache License,
// Version 2.0, that can be found in the LICENSE file.

import * as React from 'react';
import { createRoot } from 'react-dom/client';
import 'katex/dist/katex.min.css';
import '@simlin/diagram/theme.css';

import { App } from './App';
import { applyTheme, getStoredTheme } from './theme';

// Set data-theme before React renders so the first paint matches the
// persisted preference (or system preference on first visit), avoiding a
// flash of light-themed content if the user prefers dark mode.
applyTheme(getStoredTheme());

const element = document.getElementById('root');
if (element) {
  const root = createRoot(element);
  root.render(<App />);
}
